import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark.js";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import ContentCard from "../../common/template/contentCard";
import AlertIcon from "../../common/alertIcon/alertIcon";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import { useRef } from "react";

export function GraficoCustoUnidadeUltimoMes(props) {
    const cores = [am4core.color("#00d7fd"), am4core.color("#3b3bff"), am4core.color("#84f3ff"), am4core.color("#0dcf9f"), am4core.color("#0effc3")];
    const [graficoCustoUnidadeUltimoMes, setGraficoCustoUnidadeUltimoMes] = useState(null);

    const scrollRef = useRef();

    //tem personalizações pro dashboard
    function montarGraficoPieGrupo(component, nome, dados = [], titulo, prefixo, sufixo, cores) {
        if (component) component.dispose();

        const chart = am4core.create(nome, am4charts.PieChart);
        chart.colors.step = 2;
        chart.innerRadius = window.innerWidth < 768 ? 30 : 50;

        chart.language.locale = locale;

        let title = chart.titles.create();
        title.text = titulo;
        title.fontSize = window.innerWidth < 768 ? 12 : 16;
        // Permitir quebra de linha
        title.wrap = true;

        // Definir largura máxima para o título (em pixels)
        title.maxWidth = window.innerWidth * 0.9; // por exemplo, 90% da largura da tela

        // Opcional: centralizar
        title.textAlign = "middle";
        title.marginBottom = 10;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "Gráfico";
        chart.exporting.menu.align = "right";
        chart.exporting.menu.verticalAlign = "top";
        chart.exporting.menu.items = [
            {
                label: "...",
                menu: [
                    {
                        type: "png",
                        label: "PNG",
                    },
                ],
            },
        ];

        // chart.legend = new am4charts.Legend()
        // chart.legend.position = 'top'
        // chart.legend.paddingBottom = 20
        // chart.legend.labels.template.maxWidth = 95
        chart.language.locale["_decimalSeparator"] = ",";
        chart.language.locale["_thousandSeparator"] = ".";
        chart.numberFormatter.numberFormat = "#,###.00";
        chart.hiddenState.properties.opacity = 0;
        // chart.legend = new am4charts.Legend();

        var series = chart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "value";
        series.dataFields.category = "category";
        if (cores) {
            series.colors.list = cores;
        }
        chart.colors.step = 2; // Aumenta o espaçamento entre tons para variedade

        series.slices.template.tooltipText = `{category}: [bold]${prefixo} {value.formatNumber("#,###.00")} ${sufixo}[/]`;

        series.slices.template.events.on("hit", function (ev) {
            let series = ev.target.dataItem.component;
            series.slices.each(function (item) {
                if (item.isActive) {
                    item.isActive = false;
                    let itemDado = dados.filter((dado) => dado.agrupador == item.dataItem.properties.category)[0];
                    if (itemDado && itemDado.evento) {
                        itemDado.evento();
                    }
                }
            });
        });

        let data = [];
        let total = 0;
        dados
            // .filter((item) => item.id_fatura)
            .forEach((item) => {
                data.push({
                    category: item.agrupador,
                    value: item.valor,
                    mostrar: !!item.id_fatura,
                });
                total += parseFloat(item.valor);
            });

        chart.data = data;

        // Ocultar tooltip para itens sem id_fatura
        series.slices.template.adapter.add("tooltipText", (text, target) => {
            if (target.dataItem && target.dataItem.dataContext && !target.dataItem.dataContext.mostrar) {
                return ""; // sem tooltip
            }
            return `{category}: [bold]${prefixo} {value.formatNumber("#,###.00")} ${sufixo}[/]`;
        });

        // Ocultar label de valor (dentro da fatia)
        series.labels.template.adapter.add("text", (text, target) => {
            if (target.dataItem && target.dataItem.dataContext && !target.dataItem.dataContext.mostrar) {
                return ""; // sem label
            }
            return text;
        });

        var label = series.createChild(am4core.Label);
        label.text = `R$ ${adicionarPontosMilhar(total, 0)}`;
        label.horizontalCenter = "middle";
        label.verticalCenter = "middle";
        label.fontSize = window.innerWidth < 768 ? 12 : 16;

        // Força labels sempre visíveis e medidos
        series.alignLabels = true;
        series.labels.template.isMeasured = true;
        series.labels.template.wrap = true;
        series.labels.template.truncate = false;

        // Ajuste automático no mobile
        chart.events.on("sizechanged", function () {
            if (chart.pixelWidth < 768) {
                chart.radius = am4core.percent(60);
                series.labels.template.fontSize = 9;
                series.labels.template.maxWidth = 60; // ou 100, teste o valor
            } else {
                chart.radius = am4core.percent(100);
                series.labels.template.fontSize = 13;
                series.labels.template.maxWidth = 200; // ou 200, teste o valor
            }
        });

        // padding extra no chart para não cortar labels
        chart.padding(20, 20, 40, 20); // top, right, bottom, left

        return chart;
    }

    useEffect(() => {
        const listaPizza = [...props.listaGraficoCustoPorUnidadeAcumuladoAno]
            .sort((a, b) => a.valor - b.valor)
            .map((barras) => {
                const item = props.listaGraficoCustoUnidadeUltimoMes.find((pizza) => pizza.numero + " - " + pizza.agrupador === barras.agrupador);

                const hoje = new Date();
                const ano = hoje.getFullYear();
                const mesAtual = hoje.getMonth() + 1 < 10 ? "0" + (hoje.getMonth() + 1) : "" + (hoje.getMonth() + 1);
                const mesAnterior = hoje.getMonth() < 1 ? "12" : (hoje.getMonth() < 10 ? "0" : "") + hoje.getMonth();
                const competencia = props.filtro.mes_base == 1 ? `${ano}${mesAtual}` : `${ano}${mesAnterior}`;
                const agrupador = item ? item.numero + " - " + item.agrupador : barras.agrupador;
                const valor = item ? item.valor : 0;

                return {
                    id_fatura: item ? item.id_fatura : null, //nulos sao ignorados no grafico pizza
                    agrupador: `${agrupador.substring(0, agrupador.length > 30 ? 30 : agrupador.length)}${agrupador.length > 30 ? "..." : ""}`,
                    valor,
                    evento: () => {
                        if (!item) return; //na lista de barra tem todas UCs, no de pizza só as que tem fatura, então itera a lista de barras para ter a mesma quantidade de UCs, e ficarem da mesma cor nos 2 gráficos
                        props.buscarPdf(item.id_fatura, `UC-${item.numero.trim()}_${String(competencia).substring(4, 6)}-${String(competencia).substring(0, 4)}`, true);
                        props.setArquivoPDF();
                    },
                };
            });

        const graficoCustoUnidadeUltimoMesAtualizado = montarGraficoPieGrupo(graficoCustoUnidadeUltimoMes, "graficoCustoUnidadeUltimoMes", listaPizza, ``, "R$", "", cores);

        if (!graficoCustoUnidadeUltimoMes) {
            setGraficoCustoUnidadeUltimoMes(graficoCustoUnidadeUltimoMesAtualizado);
        }
        return () => {
            if (graficoCustoUnidadeUltimoMes) graficoCustoUnidadeUltimoMes.dispose();
        };
    });

    am4core.useTheme(am4themes_dark);

    const todasImportadas =
        props.listaGraficoCustoUnidadeUltimoMes.length &&
        props.listaGraficoCustoUnidadeUltimoMes.length ==
            props.listaUnidadeConsumidora.filter((uc) => uc.id_cliente == props.filtro.id_cliente && (!uc.data_desligamento || new Date(uc.data_desligamento) >= new Date()))
                .length;

    const el = scrollRef.current;
    if (el && window.innerWidth < 962) {
        // Centraliza o scroll horizontal
        el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
    }
    return (
        <ContentCard style={{ backgroundColor: "#30303d", color: "#fff" }}>
            <div
                ref={scrollRef}
                style={{
                    padding: 0,
                    backgroundColor: "#30303d",
                    overflowX: "auto",
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    justifyContent: "start",
                    height: window.innerWidth < 962 ? 500 : 550,
                }}
            >
                {todasImportadas ? (
                    <div
                        style={{
                            border: "2px solid #00f381",
                            width: window.innerWidth < 962 ? "100%" : 305,
                            color: "#FFF",
                            display: "flex",
                            padding: 4,
                            fontSize: "1rem",
                            justifyContent: window.innerWidth < 962 ? "center" : "left",
                        }}
                    >
                        <i style={{ color: '#00f381"' }} className="p-2 fas fa-check" />
                        <span className="mt-1 ml-1"> Todas as faturas foram importadas</span>
                    </div>
                ) : (
                    <div
                        style={{
                            border: "2px solid red",
                            width: window.innerWidth < 962 ? "100%" : 305,
                            color: "#FFF",
                            display: "flex",
                            padding: 4,
                            fontSize: "1rem",
                            justifyContent: window.innerWidth < 962 ? "center" : "left",
                        }}
                    >
                        <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                        <span className="mt-1 ml-1"> Faltam faturas a serem importadas</span>
                    </div>
                )}
                <p
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "clamp(0.8rem, 1vw,1rem)",
                        fontWeight: "bolder",
                        marginBlock: 20,
                    }}
                >{`Representação de Custos ${props.filtro.mes_base == 1 ? "da Última Fatura" : "da Fatura do Mês Anterior"} de Cada UC (R$)`}</p>
                <div id="graficoCustoUnidadeUltimoMes" style={{ marginTop: 20, width: "100%", height: window.innerWidth < 962 ? "100%" : 500 }}></div>
            </div>
        </ContentCard>
    );
}
